import { tenants } from "./tenants.js";

const [tenant] = Object.values(tenants);
if (!tenant) {
	throw new Error("No tenants defined");
}
const defaultTenant = tenant;

export { defaultTenant };
